import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useProductData from "pages/SuperAdmin/Company/data/data";
import useColumns from "pages/SuperAdmin/Company/columns/mainColumns";
import useColumnsTwo from "pages/SuperAdmin/Company/columns/subColumns";
import Modal from "components/Modal/SuperAdmin/create/createCompany";
import SearchBar from "components/TableExplanded/SearchBar";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SaveIcon from "@mui/icons-material/Save";
import { CreateInput } from "thai-address-autocomplete-react";

import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import dayjs from "dayjs";
import api from "_api";

const InputThaiAddress = CreateInput();
const Company = ({ className }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [fetchData, setFetchData] = useState();
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query

  const fetchProductData = async () => {
    try {
      const { data, isStatus } = await api.super_admin.getAllCompany();
      // console.log("data", data);
      if (isStatus) setFetchData(data);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData();
  }, []);

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const data = useProductData(fetchData);
  const columns = useColumns(setProduct, handleModalOpen, fetchData);
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  useEffect(() => {
    setFilteredRows(data);
  }, [data]);

  const filteredData = useMemo(() => {
    if (!searchQuery) return data; // If no search query, return all data

    return data.filter((row) => {
      return visibleColumns.some((column) => {
        const cellValue = row[column.accessor]?.toString()?.toLowerCase();
        return cellValue && cellValue.includes(searchQuery.toLowerCase());
      });
    });
  }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    // Check if event.target and event.target.value are defined
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      setSearchTerm(event.target.value.toLowerCase());
      setSearchQuery(event.target.value);
    } else {
      console.error("Event target or value is undefined");
    }
  };

  const handleClear = () => {
    setSearchTerm("");
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            ร้าน/บริษัท
          </Typography>
          <Grid display={"flex"} style={{ gap: "8px" }}>
            <GradientButtonOutline
              onClick={handleModalOpen}
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "48px",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>
                ส่งออก Excel
              </Typography>
              <SaveIcon fontSize="medium" />
            </GradientButtonOutline>
            <GradientButton
              onClick={handleModalOpen}
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "48px",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>
                สร้างบริษัท
              </Typography>
              <AddCircleIcon fontSize="medium" />
            </GradientButton>
          </Grid>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        QRCode={true}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={filteredData.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )}
      />
      <CustomPagination
        count={filteredData.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={fetchProductData}
      />
    </div>
  );
};

export default Company;
